export const languageCodeToName = (code?: string | null) => {
  switch (code) {
    case 'en':
      return 'English'
    case 'es':
      return 'Spanish'
    case 'bn':
      return 'Bengali'
    case 'bg':
      return 'Bulgarian'
    case 'cs':
      return 'Czech'
    case 'fi':
      return 'Finnish'
    case 'fr':
      return 'French'
    case 'da':
      return 'Danish'
    case 'de':
      return 'German'
    case 'it':
      return 'Italian'
    case 'id':
      return 'Indonesian'
    case 'pt':
      return 'Portuguese'
    case 'ru':
      return 'Russian'
    case 'ja':
      return 'Japanese'
    case 'ko':
      return 'Korean'
    case 'zh':
      return 'Chinese'
    case 'ar':
      return 'Arabic'
    case 'he':
      return 'Hebrew'
    case 'hi':
      return 'Hindi'
    case 'hr':
      return 'Croatian'
    case 'hu':
      return 'Hungarian'
    case 'ms':
      return 'Malay'
    case 'nl':
      return 'Dutch'
    case 'pl':
      return 'Polish'
    case 'tr':
      return 'Turkish'
    case 'vi':
      return 'Vietnamese'
    case 'th':
      return 'Thai'
    case 'sv':
      return 'Swedish'
    case 'sw':
      return 'Swahili'
    default:
      return 'English (Default)'
  }
}

export const LANGUAGE_CODES = [
  'en',
  'es',
  'bn',
  'bg',
  'cs',
  'fi',
  'fr',
  'da',
  'de',
  'it',
  'id',
  'pt',
  'ru',
  'ja',
  'ko',
  'zh',
  'ar',
  'he',
  'hi',
  'hr',
  'hu',
  'ms',
  'nl',
  'pl',
  'tr',
  'vi',
  'th',
  'sv',
  'sw',
]
